import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import FutureLayout from "../../components/futurelayout"
import FutureSEO from "../../components/futureseo"

import "../../style/main.scss"

import FutureSubNav from "../../components/futuresubnav"
import FutureAbout from "../../components/futureabout"
import FutureSpeakers from "../../components/futurespeakers"
import FutureAgenda from "../../components/futureagenda"
import FutureJoinus from "../../components/futurejoinus"
import Location from "../../components/location"



const IndexPage = () => {
  const data = useStaticQuery(graphql`
      query {
        site {
          siteMetadata {
            speakers {
              name
              title
              image
              disabledProfile
              event
            }
            sponsorshipLevel
            sponsors {
              name
              level
              logo
              url
              width
              event
            }
            sessions {
              startTime
              endTime
              title
              description
              type
              speakers {
                name
                isModerator
              }
              event
            }
          }
        }
      }
    `)

  const {
    speakers,
    sessions,
    sponsors,
    sponsorshipLevel
  } = data.site.siteMetadata

  return (
    <FutureLayout>
      <FutureSEO title="Future of Government & Education Live 2020 | June" />
      <FutureSubNav />
      <FutureAbout sponsors={sponsors} sponsorshipLevel={sponsorshipLevel} />
      <FutureSpeakers speakers={speakers} />
      <FutureAgenda sessions={sessions} speakers={speakers} />
      <FutureJoinus />
      
    </FutureLayout>
  )
}

export default IndexPage